import { useState, useEffect } from "react";
import { fetchRoutePrice } from "../data/routeData";

export function useRoutePrices(routes) {
  const [prices, setPrices] = useState({});

  useEffect(() => {
    const init = {};
    routes.forEach(r => { init[r.slug] = "loading"; });
    setPrices(init);

    routes.forEach(async (route) => {
      const price = await fetchRoutePrice(route.from, route.to, "one");
      setPrices(prev => ({ ...prev, [route.slug]: price }));
    });
  }, []);

  return prices;
}